import { render } from "./notificaciones.vue?vue&type=template&id=79b7f547&scoped=true"
import script from "./notificaciones.vue?vue&type=script&lang=js"
export * from "./notificaciones.vue?vue&type=script&lang=js"

import "./notificaciones.vue?vue&type=style&index=0&id=79b7f547&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b7f547"]])

export default __exports__